// Chakra imports
import {ChakraProvider, Portal, useDisclosure} from '@chakra-ui/react';
import Configurator from 'components/Configurator/Configurator';
import Footer from 'components/Footer/Footer.js';
// Layout components
import AdminNavbar from 'components/Navbars/AdminNavbar.js';
import Sidebar from 'components/Sidebar';
import React, {useState} from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
// Custom Chakra theme
import theme from 'theme/theme.js';
import FixedPlugin from '../components/FixedPlugin/FixedPlugin';
// Custom components
import MainPanel from '../components/Layout/MainPanel';
import PanelContainer from '../components/Layout/PanelContainer';
import PanelContent from '../components/Layout/PanelContent';
import schoolRoutes from "../schoolRoutes";
import BellScheduler from "../Scheduler/BellScheduler";
import AnnouncementScheduler from "../Scheduler/AnnouncementScheduler";
import {getLocalizedRouteName, useLanguage} from "../contexts/LanguageContext";

export default function Dashboard(props) {
    const {language} = useLanguage();
    const {...rest} = props;
    // states and functions
    const [sidebarVariant, setSidebarVariant] = useState('transparent');
    const [fixed, setFixed] = useState(false);
    // functions for changing the states from components
    const getRoute = () => {
        return window.location.pathname !== '/admin/full-screen-maps';
    };
    const getActiveRoute = (routes) => {
        let activeRoute = 'Default Brand Text';
        for (let i = 0; i < routes.length; i++) {
            if (routes[i].collapse) {
                let collapseActiveRoute = getActiveRoute(routes[i].views);
                if (collapseActiveRoute !== activeRoute) {
                    return collapseActiveRoute;
                }
            } else if (routes[i].category) {
                let categoryActiveRoute = getActiveRoute(routes[i].views);
                if (categoryActiveRoute !== activeRoute) {
                    return categoryActiveRoute;
                }
            } else {
                if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
                    return getLocalizedRouteName(routes[i], language);
                }
            }
        }
        return activeRoute;
    };
    // This changes navbar state(fixed or not)
    const getActiveNavbar = (routes) => {
        let activeNavbar = false;
        for (let i = 0; i < routes.length; i++) {
            if (routes[i].category) {
                let categoryActiveNavbar = getActiveNavbar(routes[i].views);
                if (categoryActiveNavbar !== activeNavbar) {
                    return categoryActiveNavbar;
                }
            } else {
                if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
                    if (routes[i].secondaryNavbar) {
                        return routes[i].secondaryNavbar;
                    }
                }
            }
        }
        return activeNavbar;
    };
    const getRoutes = (routes) => {
        return routes.map((prop, key) => {
            if (prop.collapse) {
                return getRoutes(prop.views);
            }
            // Recurse into any grouped category (account, attendance, noticeBoard…)
            // so their sub-menu pages get registered as routes, not just account.
            if (prop.category) {
                return getRoutes(prop.views);
            }
            if (prop.layout === '/admin') {
                return <Route path={prop.layout + prop.path} component={prop.component} key={key}/>;
            } else {
                return null;
            }
        });
    };
    const {isOpen, onOpen, onClose} = useDisclosure();
    document.documentElement.dir = 'ltr';
    // Chakra Color Mode
    return (
        <ChakraProvider theme={theme} resetCss={false}>
            <BellScheduler/>
            <AnnouncementScheduler/>
            <Sidebar
                routes={schoolRoutes}
                logoText={'PURITY UI DASHBOARD'}
                display='none'
                sidebarVariant={sidebarVariant}
                {...rest}
            />
            <MainPanel
                w={{
                    base: '100%',
                    xl: 'calc(100% - 260px)'
                }}>
                <Portal>
                    <AdminNavbar
                        routes={schoolRoutes}
                        onOpen={onOpen}
                        logoText={'Digital Ghanti'}
                        brandText={getActiveRoute(schoolRoutes)}
                        secondary={getActiveNavbar(schoolRoutes)}
                        fixed={fixed}
                        {...rest}
                    />
                </Portal>
                {getRoute() ? (
                    <PanelContent>
                        <PanelContainer>
                            <Switch>
                                {getRoutes(schoolRoutes)}
                                <Redirect from='/admin' to='/admin/dashboard'/>
                            </Switch>
                        </PanelContainer>
                    </PanelContent>
                ) : null}
                <Footer/>
                <Portal>
                    <FixedPlugin secondary={getActiveNavbar(schoolRoutes)} fixed={fixed} onOpen={onOpen}/>
                </Portal>
                <Configurator
                    secondary={getActiveNavbar(schoolRoutes)}
                    isOpen={isOpen}
                    onClose={onClose}
                    isChecked={fixed}
                    onSwitch={(value) => {
                        setFixed(value);
                    }}
                    onOpaque={() => setSidebarVariant('opaque')}
                    onTransparent={() => setSidebarVariant('transparent')}
                />
            </MainPanel>
        </ChakraProvider>
    );
}
